import type { CustomerProfile, CustomerSubscription } from '../types/customer';
import type { RawCustomerDetails, RawCustomerSubscription } from '@/lib/api/audience/types';

/**
 * Maps raw subscription data from API to typed CustomerSubscription format
 */
function mapCustomerSubscription(rawSubscription: RawCustomerSubscription): CustomerSubscription {
    return {
        subscriptionId: rawSubscription.subscription_id,
        title: rawSubscription.title,
        status: rawSubscription.status,
        billingInterval: rawSubscription.billing_interval,
        validUntil: rawSubscription.valid_until,
        subscriptionImage: rawSubscription.subscription_image,
        updatedAt: rawSubscription.updated_at,
    };
}

/**
 * Maps raw customer data from API to typed CustomerProfile format
 * Handles both snake_case and camelCase field names for backward compatibility
 * Enriches data with Stripe connection flags and user's currency preference
 */
export function mapCustomerDetails(data: RawCustomerDetails, userFanId: number): CustomerProfile {
    return {
        id: userFanId,
        fullName: data.fullName || '',
        email: data.email || '',
        phoneNumber: data.phoneNumber || null,
        totalSpent: data.totalSpent || 0,
        fanSince: data.fanSince || null,
        fanTags: data.fanTags || [],
        upcomingAppointments: data.upcomingAppointments || [],
        subscriptions: (data.subscriptions || []).map(mapCustomerSubscription),
    };
}
